import React from 'react'


export default function Logo(props){

    const { logo, click } = props

    return (
        <div onClick={click} style={{backgroundImage: `url(${logo})`, backgroundPosition: 'center', backgroundSize: 'cover', width: 80, height: 80, margin: '10px 0', cursor: 'pointer'}}/>
    )
}